import { useEffect, useRef, useState } from "react";

type EditableTextProps = {
  write: (string) => void;
  onFocus?: () => void;
  value: string;
  toggleEdit?: boolean;
};

export const EditableText = (props: EditableTextProps) => {
  const { write, value, onFocus, toggleEdit } = props;
  const [editing, setEditing] = useState(false);
  const [text, setText] = useState(value);
  const ref = useRef<HTMLInputElement>(null);

  const onChange = (e) => {
    e.preventDefault();
    if (!toggleEdit) {
      write(e.target.value);
    } else {
      setText(e.target.value);
    }
  };

  const onKeyDown = (e) => {
    if (!toggleEdit) {
      return;
    }
    if (e.key === "Enter") {
      setEditing(false);
      write(text);
    }
  };

  const onBlur = (e) => {
    if (!toggleEdit) {
      return;
    }
    setEditing(false);
    write(text);
  };

  const onClick = async () => {
    setEditing(true);
  };

  // useEffect(() => {
  //   if (toggleEdit && ref.current) {
  //     ref.current.focus();
  //     ref.current.select();
  //   }
  // }, [ref, editing]);

  return (
    <div>
      {editing || !toggleEdit
        ? (
          <input 
            type="text"
            value={toggleEdit ? text : value}
            onChange={onChange}
            onFocus={onFocus}
            onKeyDown={onKeyDown}
            onBlur={onBlur}
            ref={ref}
          />
        )
        // : <span onClick={onClick}>{value}</span>}
        : <input type="text" value={value} onFocus={onClick} />}
    </div>
  );
};
